
import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';

import {  Link, withRouter } from 'react-router-dom';

import pathConstants from '../../../constants/paths';
import { BaseLabel } from '../../../styled/labels/labels';
import { COLOR_1, COLOR_13, COLOR_18, COLOR_17 } from '../../../styled/variables/variables';
import BarsChart from './bars-chart/BarsChart';
import SingleBarChart from './single-bar-chart/SingleBarChart';
import { mqTablet } from '../../../styled/helpers/helpers';
const Stats = ({
  fill,
  views,
  favorites,
  viewsByMonth,
  messages,
}) => {
  let linkProfile;
  if (Math.ceil(fill) !==100) {
    linkProfile = <CompleteProfileCallLink to={ {
      pathname: pathConstants.CONFIG_ACCOUNT_PROFILE
    } }>Completar cadastro.</CompleteProfileCallLink>;
  } else {
    linkProfile = <CompleteProfile>Cadastro completo!</CompleteProfile>;
  }
  return (

    <Wrapper>

      <ProfileData>
      <div className={"dashboard-visualizacao"}>
        <SectionTitle>perfil</SectionTitle>
        <DataWrapperTop>
          <DataTitle>Visualizações</DataTitle>
          <BarsChart
            keyValuePairs={
              viewsByMonth.map(({ month, count, year }) => ({
                key: month,
                value: count,
                year: year
              }))
            }
          />
        </DataWrapperTop>
        </div>
        <DataWrapper>
          <DataTitle>Preenchimento</DataTitle>
          {linkProfile}
          <SingleBarChart value={ Math.ceil(fill) } />
        </DataWrapper>
      </ProfileData>

      <AdData>
      <div className={"dashboard-anuncios"}>
        <SectionTitle>anúncios</SectionTitle>
        <AdDataWrapper>
          <VerticalDataWrapper>
            <AdStatsNumber>{ messages }</AdStatsNumber>
            <AdDataTitle>MENSAGENS</AdDataTitle>
          </VerticalDataWrapper>
          <VerticalDataWrapper>
            <AdStatsNumber>{ views }</AdStatsNumber>
            <AdDataTitle>VISUALIZAÇÕES</AdDataTitle>
          </VerticalDataWrapper>
          <VerticalDataWrapper>
            <AdStatsNumber>{ favorites }</AdStatsNumber>
            <AdDataTitle>FAVORITOS</AdDataTitle>
          </VerticalDataWrapper>
        </AdDataWrapper>
        </div>
      </AdData>

    </Wrapper>
  );
};

Stats.propTypes = {

  id: propTypes.string.isRequired,
  fill: propTypes.number,
  views: propTypes.number,
  favorites: propTypes.number,
  viewsByMonth: propTypes.number,
  messages: propTypes.number,

  history: propTypes.object,
};

Stats.propTypes = {
  fill: 0,
  views: 0,
  favorites: 0,
  viewsByMonth: 0,
  messages: 0,
};

const Wrapper = styled.div`
  ${ mqTablet`
    display: flex;
    width: 100%;
    max-width: 1000px;
    align-self: center;
    margin-bottom: 70px;
  ` }
`;

const SectionTitle = styled(BaseLabel)`
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;

  ${ mqTablet`
    font-size: 14px;
  ` }
`;

const ProfileData = styled.div`
  margin-bottom: 30px;

  ${ mqTablet`
    margin: 0;
    margin-right: 20px;
    align-self: center;
    flex-grow: 1;
  ` }
`;

const DataWrapperTop = styled.div`
  padding: 15px;
  background-color: ${ COLOR_18 };
  border-radius: 1px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  height: 150px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const DataWrapper = styled.div`
  padding: 15px;
  background-color: ${ COLOR_18 };
  border-radius: 1px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;

  &:last-child {
    margin-bottom: 0;
  }
`;

const DataTitle = styled(SectionTitle)`
  font-weight: 300;
  color: ${ COLOR_17 };
  text-transform: none;
  opacity: 0.8;
`;

const CompleteProfileCallLink = styled(BaseLabel).attrs({
  as: Link,
})`
  font-weight: bold;
  font-size: 13px;
  position: absolute;
  color: ${ COLOR_13 };
  text-decoration: underline;
  opacity: 0.8;
  align-self: flex-end;
`;
const CompleteProfile = styled(BaseLabel).attrs({
  as: "a",
})`
  font-weight: bold;
  font-size: 13px;
  position: absolute;
  color: ${ COLOR_13 };
  opacity: 0.8;
  align-self: flex-end;
`;

const AdData = styled(ProfileData)`
  margin-bottom: 70px;

  ${ mqTablet`
    flex-grow: unset;
    width: 330px;
    margin: 0;
    align-self: center;
  ` }
`;

const AdDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  transform: rotate(-90deg);
  /* margin-left: -28px;
  margin-top: 30px; */
  margin: 22px auto;

  ${ mqTablet`
    width: 252px;
    margin: -22px 0px -20px 20px;
  ` }
`;

const VerticalDataWrapper = styled(DataWrapper)`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  &:last-child {
    margin-bottom: 0;
  }

  ${ mqTablet`
    height: 90px;
  ` }
`;

const AdDataTitle = styled(DataTitle)`
  align-self: center;
  text-transform: uppercase;
  margin: 0;
`;

const AdStatsNumber = styled(BaseLabel)`
  font-weight: bold;
  font-size: 38px;
  color: ${ COLOR_1 };
  margin-right: 15px;
  align-self: center;

  ${ mqTablet`
    font-size: 28px;
  ` }
`;


export default withRouter(Stats);
